import React from 'react'
import CancelIcon from '@material-ui/icons/Cancel'
import Tappable from 'react-tappable/lib/Tappable'
import getValueChip from 'root/src/client/logic/header/handlers/getValueChip'
import Chip from '@material-ui/core/Chip'
import { orNull } from 'root/src/shared/util/ramdaPlus'
import Avatar from '@material-ui/core/Avatar'

export default ({ props: { classes, value, input, onSelect, locked, style } }) => {
	const soloCleare = () => {
		if (locked) return
		onSelect(null)
		const currentInput = input.current
		currentInput.value = ''
	}
	const { image, label } = value
	return (
		<Chip
			avatar={orNull(
				image,
				<Avatar alt={label} src={image} />,
			)}
			className={classes.chip}
			style={style}
			tabIndex={-1}
			label={getValueChip(value)}
			onDelete={soloCleare}
			deleteIcon={locked ? <div /> : (
				<Tappable className={classes.chipDelete} onTap={soloCleare}>
					<CancelIcon />
				</Tappable>
			)}
		/>
	)
}
